(function (angular) {
    angular.module('bizPartEngage').controller('core.logout', logoutController);

    logoutController.$inject = ["$rootScope", "core.users.service"];

    function logoutController($rootScope, userService) {
        var vm = this;

        function Init() {
            userService.Logout();
        }

        $rootScope.Initialized.then(Init);
    }
}(window.angular));